// src/services/roleService.js

export default {
  /**
   * Store user roles in sessionStorage
   * @param {Array} roles - Array of role strings
   */
  storeRoles(roles) {
    sessionStorage.setItem('userRoles', JSON.stringify(roles))
  },

  /**
   * Get user roles from sessionStorage
   * @returns {Array} Array of role strings
   */
  getRoles() {
    const roles = sessionStorage.getItem('userRoles')
    return roles ? JSON.parse(roles) : []
  },

  /**
       * Check if the user has at least one of the specified roles.
       *
       * This method retrieves the user's roles from sessionStorage and checks
       * if any of the roles in the provided array match the user's roles.
       *
       * @param {Array} roles - An array of role strings to check against the user's roles.
       * @returns {Boolean} True if the user has at least one of the specified roles, otherwise false.
       */
  hasAtLeastOneRole(roles) {
    const userRoles = this.getRoles() // Retrieve the user's roles from sessionStorage
    return roles.some(role => userRoles.includes(role)) // Check if any role matches
  },

  /**
   * Check if user has a specific role
   * @param {String} role - Role to check
   * @returns {Boolean} True if user has the role
   */
  hasRole(role) {
    const roles = this.getRoles()
    return roles.includes(role)
  },

  /**
   * Add a role to the existing roles
   * @param {String} role - Role to add
   */
  addRole(role) {
    console.log('Adding role:', role)
    const roles = this.getRoles()
    if (!roles.includes(role)) {
      roles.push(role)
      this.storeRoles(roles)
    }
  },

  /**
   * Clear all roles
   */
  clearRoles() {
    console.log('Clearing roles')
    sessionStorage.removeItem('userRoles')
  }
}
